import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import LogItem from './LogItem';
import { HandleVibrate } from 'Utils/Helpers/HandleApiData';

export default function Logs({ items }) {
    const { dateSearch, current } = useSelector((state) => ({
        dateSearch: state.setting.dateSearch,
        current: state.staff.current,
    }));
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(false)
    },[dateSearch])

    const onMouseUp = (e) => {
        HandleVibrate();
    }
    
    return (
        <>
            {
                current[0][3] &&
                <div className="logs-list">
                    <div
                        className={`logs-head ${open ? 'active' : 'deactive'}`}
                        onClick={() => setOpen(!open)}
                        onMouseUp={onMouseUp}
                    >
                        <p className='h6'>{`لیست تغییرات در نوبت‌ها`}</p>
                        <p>{`(${items.length} مورد)`}</p>
                        <div className='icon'>
                            <icons.CaretDown />
                        </div>
                    </div>
                    {
                        open && (
                            items.length !== 0
                            ?  <div className={'total-items'}>
                                {items.map((item) => <LogItem key={item.id} item={item} />)}
                            </div>
                            : <p className='no-log'>تغییراتی در نوبت های این روز ثبت نشده است</p>
                        )
                    }
                </div>
            }
        </>
    );
}